import React from "react";
import { Menu } from "antd";
import { SimpleParagraph } from "../Paragraph";
import style from "./index.module.less";
import { Link } from "react-router-dom";

const MenuItem = ({ items }) => {
  const [current, setCurrent] = React.useState();

  const onClick = (e) => {
    console.log("item", e);
    setCurrent(e.key);
  };

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode='horizontal'
      items={items}
      className={style.MenuItemWrapper}
    />
  );
};

export default MenuItem;
